import { Component, computed, inject } from '@angular/core'
import { RouterModule } from '@angular/router'
import { NavContextService, NavSeason } from '../../services/nav-context.service'

/**
 * The way up from an entity page: Cyprus › First Division › APOEL, each step a link.
 *
 * Every entity layout publishes its trail through NavContextService (the last item is the
 * page itself), so this renders nothing of its own. Hidden when no step links anywhere —
 * a trail of plain text is noise. On a phone the trail becomes one "‹ parent" chip: the
 * full row does not fit beside the thumb, and one step up is what the chip is for.
 */
@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
})
export class BreadcrumbsComponent {
  private readonly navCtx = inject(NavContextService)

  readonly items = this.navCtx.breadcrumbs
  // Pages with section tabs show the way up as the chevron at the start of the phone tab row,
  // so on a phone this row only appears where there are no tabs (e.g. a country page).
  readonly hasTabs = this.navCtx.hasContext
  // The nearest ancestor that links — the chip's target on a phone.
  readonly up = computed(() => {
    const parents = this.items().slice(0, -1)
    return [...parents].reverse().find((i) => !!i.link) ?? null
  })
  // Season picker at the end of the row (desktop; the phone tab row has its own).
  readonly season = this.navCtx.season

  onSeasonChange (season: NavSeason, event: Event): void {
    const value = (event.target as HTMLSelectElement).value
    if (value) season.onChange(value)
  }
}
